import React from 'react'
import { useIsRecurly } from 'sb-hooks'
import { modalVisibility, ModalVisibilityProps, openModal } from 'sb-modal'

import UnsubscribeReasonModalView from './UnsubscribeReasonModalView/UnsubscribeReasonModalView'

import useUnsubscribeReasonModalVindicia from './util/useUnsubscribeReasonModalVindicia'
import useUnsubscribeReasonModalRecurly from './util/useUnsubscribeReasonModalRecurly'


const UnsubscribeReasonModalVindicia: React.FunctionComponent<ModalVisibilityProps> = (props) => {
  const { form, reasons, isFetching, onSubmit, onClose } = useUnsubscribeReasonModalVindicia(props)

  return (
    <UnsubscribeReasonModalView
      form={form}
      reasons={reasons}
      isFetching={isFetching}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  )
}

const UnsubscribeReasonModalRecurly: React.FunctionComponent<ModalVisibilityProps> = (props) => {
  const { form, reasons, isFetching, onSubmit, onClose } = useUnsubscribeReasonModalRecurly(props)

  return (
    <UnsubscribeReasonModalView
      form={form}
      reasons={reasons}
      isFetching={isFetching}
      onSubmit={onSubmit}
      onClose={onClose}
    />
  )
}

const UnsubscribeReasonModal: React.FunctionComponent<ModalVisibilityProps> = (props) => {
  const isRecurly = useIsRecurly()

  return React.createElement(
    isRecurly ? UnsubscribeReasonModalRecurly : UnsubscribeReasonModalVindicia,
    props
  )
}


export const openUnsubscribeReasonModal = () => openModal('unsubscribeReason')


export default modalVisibility('unsubscribeReason', UnsubscribeReasonModal)
